export default __webpack_public_path__ + "assets/appleStore.16349f4b.png";